import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { HomePage } from "~/pages/Home/HomePage";

export const Route = createFileRoute("/_app/")({
  head: () => ({ meta: [{ title: i18n.t("general:header.home") }] }),
  component: HomePage,
});
